import classnames from 'classnames'
import Text from './'
import { ConditionalTooltip } from '../app/ConditionalTooltip'

const TextActionLink = ({ value, ...otherProps }) => {
	const condition = value?.length > 30

	return (
		<ConditionalTooltip condition={condition} value={value}>
			<Text
				role="link"
				tabIndex="0"
				aria-label={value}
				size="md"
				className={classnames('font-weight-bold text-primary', { 'text-truncate': condition })}
				style={{ cursor: 'pointer' }}
				{...otherProps}
			>
				{value}
			</Text>
		</ConditionalTooltip>
	)
}

export default TextActionLink
